export default "__VITE_ASSET__59187559__"